import { Component, computed, input } from '@angular/core';
import { NgStyle } from '@angular/common';

export type ArrowDirection =
  | 'up' | 'right' | 'down' | 'left'
  | 'bottom-right' | 'bottom-left' | 'top-right' | 'top-left';

@Component({
  standalone: true,
  selector: 'app-arrow',
  imports: [NgStyle],
  templateUrl: './arrow.html',
  styleUrl: './arrow.scss',
})
export class Arrow {
  stroke = input('#000000');
  width = input('0.75rem');
  height = input('0.75rem');
  direction = input<ArrowDirection>('right');

  rotation = computed(() => {
    switch (this.direction()) {
      case 'right':        return 0;
      case 'bottom-right': return 45;
      case 'down':         return 90;
      case 'bottom-left':  return 135;
      case 'left':         return 180;
      case 'top-left':     return 225;
      case 'up':           return 270;
      case 'top-right':    return 315;
      default:             return 0;
    }
  });
}
